import { activityFamily, neatActivityTitle } from "./weekScheduleGrid";
import { DAY_ACTIVITY_SLOTS, SLOT_OVERRIDE_KEY, splitStoredOverrides } from "../constants/dayActivities";

/** Keep downloaded daily activity rows in sync with the live planner labels. */
export function applyCurrentActivityTitles(rows = [], currentOverrides = null) {
  let overrides = currentOverrides || {};
  if (!currentOverrides) {
    try {
      overrides = splitStoredOverrides(JSON.parse(localStorage.getItem(SLOT_OVERRIDE_KEY) || "{}")).daily;
    } catch { /* Use the activity names saved with the plan. */ }
  }
  return (rows || [])
    .filter((row) => {
      const family = activityFamily(row?.[2]);
      const preset = DAY_ACTIVITY_SLOTS.find((slot) => slot.id === family);
      const raw = String(row?.[2] || "").trim();
      const isBaseTitle = preset && (raw === preset.label || (neatActivityTitle(raw) === preset.label && raw.length <= preset.label.length + 4));
      return !(isBaseTitle && overrides[family]?.mode === "hide");
    })
    .map((row) => {
      const family = activityFamily(row?.[2]);
      const preset = DAY_ACTIVITY_SLOTS.find((slot) => slot.id === family);
      const raw = String(row?.[2] || "").trim();
      const isBaseTitle = preset && (raw === preset.label || (neatActivityTitle(raw) === preset.label && raw.length <= preset.label.length + 4));
      const override = isBaseTitle ? overrides[family] : null;
      return override?.title ? [row[0], row[1], override.title, ...row.slice(3)] : row;
    });
}
